import React, { createContext, useState, useContext, useEffect } from "react";

// 지원하는 언어 목록
export const supportedLanguages = [
  { code: "ko", name: "한국어" },
  { code: "en", name: "English" },
  { code: "ja", name: "日本語" },
  { code: "zh-CN", name: "简体中文" },
  { code: "zh-TW", name: "繁體中文" },
  { code: "it", name: "Italiano" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
  { code: "es", name: "Español" },
  { code: "ru", name: "Русский" },
  { code: "pt", name: "Português" },
  { code: "ar", name: "العربية" },
  { code: "hi", name: "हिन्दी" },
];

// 언어 Context 생성
const LanguageContext = createContext();

// Context Provider 컴포넌트
export const LanguageProvider = ({ children }) => {
  // 기본 언어는 한국어, 로컬스토리지에서 저장된 언어 불러오기
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("i2m_language");
    return savedLanguage || "ko";
  });

  // 언어 변경 함수
  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
    // 로컬스토리지에 언어 설정 저장
    localStorage.setItem("i2m_language", langCode);
    console.log(`언어가 변경되었습니다: ${langCode}`);
  };

  // Provider 값으로 현재 언어와 언어 변경 함수 제공
  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 커스텀 훅으로 Context 사용 간편화
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;
